import { useApolloClient, useMutation } from '@apollo/client';
import { useSnackbar } from 'notistack';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { DeleteUserDocument } from '../../../graphql/mutation/users/DeleteUser.generated.tsx';

export const useApiKeyDelete = () => {
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();
  const apolloClient = useApolloClient();

  const [deleteUserMutation, { loading }] = useMutation(DeleteUserDocument, {
    refetchQueries: ['GetOrgApiKeys'],
  });

  const deleteApiKey = useCallback(
    async (id: string) => {
      try {
        await deleteUserMutation({
          onCompleted: () => {
            apolloClient.cache.evict({ fieldName: 'user', id: 'ROOT_QUERY' });
            enqueueSnackbar('API Key deleted successfully', { variant: 'success' });
          },
          variables: { id },
        });
      } catch (error) {
        const defaultErrorMessage = t('Failed to delete API Key');
        const message = error[0]?.message;

        enqueueSnackbar(message ?? defaultErrorMessage, { variant: 'error' });
      }
    },
    [apolloClient, deleteUserMutation, enqueueSnackbar, t]
  );

  return { deleteApiKey, loading };
};
